import { render, staticRenderFns } from "./DetalheCampanhaSms.vue?vue&type=template&id=4979d2a7&scoped=true"
import script from "./DetalheCampanhaSms.vue?vue&type=script&lang=js"
export * from "./DetalheCampanhaSms.vue?vue&type=script&lang=js"
import style0 from "./DetalheCampanhaSms.vue?vue&type=style&index=0&id=4979d2a7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4979d2a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4979d2a7')) {
      api.createRecord('4979d2a7', component.options)
    } else {
      api.reload('4979d2a7', component.options)
    }
    module.hot.accept("./DetalheCampanhaSms.vue?vue&type=template&id=4979d2a7&scoped=true", function () {
      api.rerender('4979d2a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DetalheCampanhaSms.vue"
export default component.exports